import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Clothes = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M8.044 4l1.284.59A13.557 13.557 0 0014.152 5.8c1.676.104 3.33.428 4.922.965l1.39.47-.46 1.443c-.117.367-.239.733-.366 1.097.042.013.086.03.13.045l1.233.455-.486 1.719a28.3 28.3 0 01-4.16 8.69l-.226.314-1.006-.515a10.348 10.348 0 00-4.53-1.14l-.248-.002a10.202 10.202 0 01-4.771-1.156l-1.021-.532.856-1.285a12.61 12.61 0 01-1.275-.534L3 15.285l2.24-3.629A20.323 20.323 0 008.044 4zm11.254 6.716a42.708 42.708 0 01-3.468 7.144l-.41.662-1.131-.418a16.597 16.597 0 00-5.128-1.016 12.61 12.61 0 01-2.761-.412l-.404.605.032.017a9.216 9.216 0 004.06 1.042l.25.002c1.73-.01 3.442.38 5.001 1.135l.233.116.243.124.175-.257a27.304 27.304 0 003.461-7.366l.11-.375.232-.825-.365-.134-.13-.044zM11.763 7.83l-.65 1.33-1.313.648 1.313.658.65 1.32.66-1.32 1.303-.658-1.302-.648-.661-1.33zM4 8l.337.672L5 9l-.663.332L4 10l-.33-.668L3 9l.67-.328L4 8zm9-6l.337.672L14 3l-.663.332L13 4l-.33-.668L12 3l.67-.328L13 2z"
        id="prefix__a-clothes"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="prefix__b-clothes" fill="#fff">
        <use xlinkHref="#prefix__a-clothes" />
      </mask>
      <use fill="#FFF" xlinkHref="#prefix__a-clothes" />
      <g
        mask="url(#prefix__b-clothes)"
        fill={props.color || theme.palette.grey800}
      >
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
);
